export const state = {
    errors: [],
    error: '',
    success: '',
};